import { useCallback } from "react";

const useHandleKeyDown = () => {
    return useCallback((event) => {
        if (event.key === "Enter") {
            event.preventDefault();
        }
    }, []);
};

export default useHandleKeyDown;